import { moduleProviderFactory } from 'core/providers';
import { isSuperAdminOrganizationType } from 'core/utils';
import { BillingCharges, BillingQuickBooks } from './pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.billing',
				pattern: '/billing',
				isPrivate: true,
				// SSDV-3497: hidden in production until released
				authorization: rootStore => process.env.NODE_ENV !== 'production' && isSuperAdminOrganizationType(rootStore),
				children: [
					// A page under the menu entry's own route name: the menu only shows entries whose route is a page,
					// and a route with children isn't one. It also keeps old /billing links working.
					{
						name: 'master.app.main.billing',
						pattern: '',
						component: BillingCharges,
					},
					{
						name: 'master.app.main.billing.charges',
						pattern: '/import-charges',
						component: BillingCharges,
					},
					{
						name: 'master.app.main.billing.quickbooks',
						pattern: '/export-to-quickbooks',
						component: BillingQuickBooks,
					},
				],
			},
		],
	});
})();
